import { schema } from "normalizr";

export const userSchema = new schema.Entity(
  "users",
  {},
  { idAttribute: "userId" }
);

export const usersSchema = [userSchema];
